import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const FormsPermissionsApi = createApi({
	reducerPath: "FormsPermissions",
	baseQuery: fetchBaseQuery({
		baseUrl: process.env.REACT_APP_BACKEND_URL,
		prepareHeaders: (headers) => {
			const token = localStorage.getItem("token");
			if (token) {
				headers.set("Authorization", `Bearer ${token}`);
			}
			return headers;
		},
	}),
	endpoints: (builder) => ({
		addFormPermission: builder.mutation({
			query: (val) => ({
				url: `forms/permissions`,
				method: "POST",
				headers: { "Content-Type": "application/json" },
				body: val,
			}),
		}),
		deleteFormPermission: builder.mutation({
			query: (val) => ({
				url: `forms/permissions`,
				method: "DELETE",
				headers: { "Content-Type": "application/json" },
				body: val,
			}),
		}),
		getFormsByUser: builder.query({
			query: (userId) => `forms/permissions?userId=${userId}`,
		}),
	}),
});

export const {
	useAddFormPermissionMutation,
	useDeleteFormPermissionMutation,
	useGetFormsByUserQuery,
} = FormsPermissionsApi;
